/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterComprometimento(idContrato, idComprometimentoRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/${idContrato}/comprometimentos/${idComprometimentoRequisicao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosParcelasFixasEntregas(idContrato) {
        return axiosJwt
            .get(
                `${api}/contratos/${idContrato}/comprometimentos/parcelasfixasentregas`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    salvarRateios(comprometimentoRateios) {
        return axiosJwt
            .post(
                `${api}/contratos/${comprometimentoRateios.idContrato}/comprometimentos/${comprometimentoRateios.idComprometimentoRequisicao}`,
                comprometimentoRateios
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometer(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/${comprometimento.idContrato}/comprometimentos/${comprometimento.idComprometimentoRequisicao}/comprometer`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometerSelecionados(comprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/${comprometimentos.idContrato}/comprometimentos/comprometerselecionados`,
                comprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    descomprometer(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/${comprometimento.idContrato}/comprometimentos/${comprometimento.idComprometimentoRequisicao}/descomprometer`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarHistoricos(atualizarHistoricosDto) {
        return axiosJwt
            .post(
                `${api}/contratos/${atualizarHistoricosDto.idContrato}/comprometimentos/atualizarhistoricos`,
                atualizarHistoricosDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    bloquearDesbloquear(bloquearDesbloquearDto) {
        return axiosJwt
            .patch(
                `${api}/contratos/${bloquearDesbloquearDto.idContrato}/comprometimentos/${bloquearDesbloquearDto.idComprometimentoRequisicao}/bloqueardesbloquear`,
                bloquearDesbloquearDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    verificarSaldoNatureza(comprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/${comprometimentos.idContrato}/comprometimentos/verificarsaldonatureza`,
                comprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
